module.exports = __webpack_public_path__ + "img/hand-back-point-down.9f3d23bc.svg";